module.exports = __webpack_public_path__ + "static/media/search.1f08939d.svg";